import { ApiError } from './api.js'

/**
 * The calendars' saved copies (Charles, 2026-10-14: with no service "it
 * shows a blank page … at least show offline so one doesn't think the
 * calendar is blank"). The service worker keeps the last answer for each
 * calendar request (vite.config.js, cache 'cdm-calendar') and hands it back
 * when the network doesn't answer. Each answer carries `servedAt`, the time
 * the server made it, so the page can tell a fresh answer from a saved one
 * and say how old it is.
 */

// Online, the calendars re-ask every 5 minutes, so an answer older than
// this came from the saved copy (or the connection has been gone a while).
export const OLD_MS = 10 * 60 * 1000

/** The fetch itself failed (no service) — not an answer the server refused. */
export const isNetworkError = (err) => !(err instanceof ApiError)

export function servedAtOf(data) {
  const t = Date.parse(data?.servedAt || '')
  return Number.isFinite(t) ? t : null
}

export function isOldCopy(data, now = Date.now()) {
  const t = servedAtOf(data)
  return t != null && now - t > OLD_MS
}

/** Ask again soon while showing a saved copy, so it is replaced as soon as there is service. */
export const askAgain = (data) => (isOldCopy(data) ? 30 * 1000 : 5 * 60 * 1000)

/** "2:41 PM", "yesterday at 2:41 PM", "Mon, Oct 12 at 2:41 PM". */
export function fmtSavedAt(t) {
  const d = new Date(t)
  const clock = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
  const day = (x) => `${x.getFullYear()}-${x.getMonth()}-${x.getDate()}`
  const now = new Date()
  if (day(d) === day(now)) return clock
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
  if (day(d) === day(yesterday)) return `yesterday at ${clock}`
  return `${d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} at ${clock}`
}
